import { styled } from 'goober';

import { ApiAndIntegrations } from './api-and-integrations/api-and-integrations';
import { Feed } from './feed/feed';
import { General } from './general/general';
import { InvitedUsers } from './invited-users/invited-users';
import { ManageTemplates } from './manage-templates/manage-templates';
import { Privacy } from './privacy/privacy';
import { ProfileSettings } from './profile-settings/profile-settings';
import { UserManagement } from './user-management/user-management';
import type { SettingsTabs } from './use-settings-tabs-config';

export const SettingsTabContent = ({ tab }: { tab: SettingsTabs }) => {
  const getTabContent = (tab: SettingsTabs) => {
    switch (tab) {
      case 'apiAndIntegrations':
        return <ApiAndIntegrations />;
      case 'feed':
        return <Feed />;
      case 'general':
        return <General />;
      case 'invitedUsers':
        return <InvitedUsers />;
      case 'manageTemplates':
        return <ManageTemplates />;
      case 'privacy':
        return <Privacy />;
      case 'profileSettings':
        return <ProfileSettings />;
      case 'userManagement':
        return <UserManagement />;
    }
  };

  return <TabContentContainer>{getTabContent(tab)}</TabContentContainer>;
};

const TabContentContainer = styled('div')`
  background-color: ${({ theme }) => theme.colors.basics.white};
  padding: 24px 34px 24px 34px;
`;
